import "./MainPage.css";

import { useEffect, useState, useRef } from "react";

import { Navbar } from "../../components/navbar/Navbar";
import { Game } from "../game/Game";
import { Rating } from "../rating/Rating";
import { useLangActive } from "../../hooks/useLangActive";

import { DELAY_SAVING_CLOUD_SECONDS, LB_NAME, LS_NAME } from "../../utils/config";

function MainPage() {
	const [dataLocalStorage, setDataLocalStorage] = useState(
		JSON.parse(localStorage.getItem(LS_NAME)) || {
			id: 0,
			score: 0,
			count: 1,
			correctAnswers: 0,
			correctAnswersTest: 0,
			isMenu: false,
		}
	);
	const prevDataRef = useRef(dataLocalStorage);
	const [isAuth, setIsAuth] = useState(true);
	const [isSound, setIsSound] = useState(true);
	const [isRating, setRating] = useState(false);

	const [lang, setLang] = useLangActive();

	useEffect(() => {
		localStorage.setItem(LS_NAME, JSON.stringify(dataLocalStorage));
	}, [dataLocalStorage]);

	// set data
	useEffect(() => {
		if (typeof YaGames === "undefined" || typeof YaGames.init !== "function") {
			console.error("player.getData");
		} else {
			ysdk.features.LoadingAPI?.ready();
			console.log("ysdk.features.LoadingAPI.ready");

			ysdk.adv.showFullscreenAdv({
				callbacks: {
					onClose: function (wasShown) {
						ysdk.features.GameplayAPI?.start();
						console.log("ysdk.features.GameplayAPI.start");
					},
				},
			});

			window.player.getData().then((d) => {
				if (d.data !== undefined) {
					setDataLocalStorage(d.data);
					console.log("player.getData");
				}
			});
		}
	}, []);

	useEffect(() => {
		if (!window.player) {
			console.error("ysdk.getPlayer");
		} else {
			if (player.getMode() === "lite") {
				setIsAuth(false);
				console.log("setIsAuth.false");
			} else {
				setIsAuth(true);
				console.log("setIsAuth.true");
			}
		}
	}, [isAuth]);

	useEffect(() => {
		const interval = setInterval(() => {
			if (window.player !== undefined) {
				const isDataChanged = JSON.stringify(dataLocalStorage) !== JSON.stringify(prevDataRef.current);
				if (isDataChanged) {
					window.player.setData({ data: dataLocalStorage }).then(() => {
						prevDataRef.current = { ...dataLocalStorage };
						console.log("player.setData");
					});
					console.log("lb.setLeaderboardScore");
					window.lb.setLeaderboardScore(LB_NAME, dataLocalStorage.score);
				} else {
					console.log("The data has not changed");
				}
			} else {
				console.error("player.setData");
				console.error("lb.setLeaderboardScore");
			}
		}, DELAY_SAVING_CLOUD_SECONDS * 1000);
		return () => clearInterval(interval);
	}, [dataLocalStorage]);

	return (
		<div className="MainPage">
			<Navbar
				isSound={isSound}
				setIsSound={setIsSound}
				lang={lang}
				setLang={setLang}
				count={dataLocalStorage.count}
				setRating={setRating}
			/>
			{isRating ? (
				<Rating setRating={setRating} lang={lang} isAuth={isAuth} />
			) : (
				<Game
					lang={lang}
					isSound={isSound}
					dataLocalStorage={dataLocalStorage}
					setDataLocalStorage={setDataLocalStorage}
				/>
			)}
		</div>
	);
}

export default MainPage;
